import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { ItemTypeTitles } from './utils';
import { Icon } from '@common/components';
import { worksListItemExpirationTitles } from '@onboarding/services';

export default function ItemTemplateGroup(props) {
  const { type, items, setEditingItem } = props;

  if (items.length === 0) return;

  const columns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 300,
      className: 'type-column',
      render: (type) => ItemTypeTitles[type],
    },
    {
      title: ItemTypeTitles[type],
      dataIndex: 'name',
      key: 'name',
      width: 500,
    },
    {
      title: 'Expiration Type',
      dataIndex: 'expirationType',
      key: 'expirationType',
      render: (type) => worksListItemExpirationTitles[type],
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      className: 'action-column',
      render: (item) => (
        <a
          className="onboarding-edit-item-template-icon"
          onClick={() => setEditingItem(item)}
        >
          <Icon icon="pen" />
        </a>
      ),
    },
  ];

  return (
    <div>
      <Table
        dataSource={items}
        columns={columns}
        rowKey="id"
        pagination={false}
        className="onboarding-item-template-group"
        rowClassName={(item) => (item.active ? '' : 'disabled-row')}
      />
      <style jsx>{`
        :global(.onboarding-item-template-group) {
          margin-bottom: 25px;
        }
        :global(.onboarding-item-template-group .action-column) {
          text-align: right;
        }
        :global(.onboarding-item-template-group .type-column) {
          text-transform: uppercase;
        }
      `}</style>
    </div>
  );
}

ItemTemplateGroup.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  setEditingItem: PropTypes.func.isRequired,
};
